import { FileConfig } from './types';

export const FILE_CONFIGS: Record<string, FileConfig> = {
    salesReport: {
        headerRow: 4,
        mappings: {
            orderId: 'Номер заказа (ID/RRN)',
            address: 'Адрес точки продаж',
            terminalId: 'ID терминала',
            amount: 'Сумма операции (т)'
        }
    },
    archiveOrders: {
        headerRow: 0,
        mappings: {
            orderId: '№ заказа',
            address: 'Адрес самовывоза/доставки',
            warehouseTransfer: 'Склад передачи КД' // Новая колонка для определения терминала
        }
    }
};
